import { render, staticRenderFns } from "./SimpleModal.vue?vue&type=template&id=7dfb4dfe&scoped=true&lang=pug"
import script from "./SimpleModal.vue?vue&type=script&lang=js"
export * from "./SimpleModal.vue?vue&type=script&lang=js"
import style0 from "./SimpleModal.vue?vue&type=style&index=0&id=7dfb4dfe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dfb4dfe",
  null
  
)

export default component.exports